<div class="breadcrumb-bar">
  <div class="breadcrumb-inner">
    <button
      type="button"
      class="back-button"
      [disabled]="!navigation.canGoBack()"
      (click)="navigation.back()"
      [attr.aria-label]="'shared.navigation_bar.back_tooltip' | translate"
    >
      <svg
        class="back-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="m12 19-7-7 7-7" />
        <path d="M19 12H5" />
      </svg>
    </button>

    <nav class="breadcrumb-trail" aria-label="Breadcrumb">
      @for (item of navigation.breadcrumbs(); track $index) {
        <span class="crumb">
          @if (!$last) {
            <a
              class="crumb-link"
              [routerLink]="['/', item.route]"
              [queryParams]="queryParamsOf(item)"
            >
              {{ crumbLabel(item) }}
            </a>
            <span class="separator">&gt;</span>
          } @else {
            <span class="crumb-current">{{ crumbLabel(item) }}</span>
          }
        </span>
      }
    </nav>
  </div>
</div>
